import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { BillingAccount } from 'gql/graphql';
import { gql } from 'graphql-request';
import { TGenericError } from 'types/TGenericError';
import clientUtil from 'utils/clientUtil';

type TData = Pick<BillingAccount, 'creditCard'>;

export const useCreditCard = (
  options: Omit<UseQueryOptions<unknown, TGenericError, TData>, 'queryKey'> = {}
) => {
  const client = clientUtil();

  const graphql = gql`
    query creditCard {
      billingAccount {
        creditCard {
          brand
          expMonth
          expYear
          last4
        }
      }
    }
  `;

  return useQuery<unknown, TGenericError, TData>({
    ...options,
    queryKey: ['creditCard'],
    queryFn: async () =>
      client.request({
        data: {
          gql: graphql
        }
      })
  });
};
